import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { JUST_TEXT_BASE_CLASSNAME } from './Constants';
import { createJustText } from './JustText';
createComponents(".".concat(JUST_TEXT_BASE_CLASSNAME), createJustText, NO_PATTERN_BUSINESS_LOGIC);
